<template>
  <th scope="row" :class="extraClasses" class="text-left">
    <slot name="heading">&nbsp;</slot>
  </th>
</template>

<script>
export default {
  props: ['extraClasses'],
};
</script>
